import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type SliderTitleOfferClasses = 'container';

const sliderTitleOfferStyles = makeStyles<ISpcTheme, SliderTitleOfferClasses>(
  theme => ({
    container: {
      padding: `0 ${theme.spacing(5)}`,
      [theme.breakpoints.down('xs')]: {
        padding: `0 ${theme.spacing(2)}`,
      },
    },
  }),
  { name: 'Customise_SliderTitleOffer' },
);

export default sliderTitleOfferStyles;
